import { FormType } from '../../../form-types';

export const libidoBeluga: FormType = {
  name: 'Female Sexual Health/Libido Visit',

  questions: [
    {
      key: 'libidoBeluga_sexAssignedAtBirth',
      next: {
        condition: {
          'libidoBeluga_sexAssignedAtBirth.libidoBeluga_sexAssignedAtBirth_male':
            true
        },
        key: 'libidoBeluga_ineligible',
        els: 'libidoBeluga_pregnancy'
      }
    },
    {
      key: 'libidoBeluga_pregnancy',
      next: {
        condition: {
          'libidoBeluga_pregnancy.libidoBeluga_pregnancy_yes': true
        },
        key: 'libidoBeluga_ineligible',
        els: 'libidoBeluga_pregnancyConsent'
      }
    },
    {
      key: 'libidoBeluga_pregnancyConsent',
      next: {
        condition: {
          'libidoBeluga_pregnancyConsent.libidoBeluga_pregnancyConsent_disagree':
            true
        },
        key: 'libidoBeluga_ineligible',
        els: 'libidoBeluga_height'
      }
    },
    'libidoBeluga_height',
    'libidoBeluga_weight',
    {
      key: 'libidoBeluga_primaryConcerns',
      next: {
        condition: {
          'libidoBeluga_primaryConcerns.libidoBeluga_primaryConcerns_other':
            true
        },
        key: 'libidoBeluga_sexualHealthDetails',
        els: 'libidoBeluga_conditions'
      }
    },
    'libidoBeluga_sexualHealthDetails',
    {
      key: 'libidoBeluga_conditions',
      next: {
        switch: [
          {
            condition: {
              'libidoBeluga_conditions.libidoBeluga_conditions_otherCancer':
                true
            },
            key: 'libidoBeluga_conditionsDetails'
          },
          {
            condition: {
              'libidoBeluga_conditions.libidoBeluga_conditions_highBP': true
            },
            key: 'libidoBeluga_ineligible'
          },
          {
            condition: {
              'libidoBeluga_conditions.libidoBeluga_conditions_lowBP': true
            },
            key: 'libidoBeluga_ineligible'
          }
        ],
        els: 'libidoBeluga_duration'
      }
    },
    'libidoBeluga_conditionsDetails',
    'libidoBeluga_duration',
    'libidoBeluga_distress',
    'libidoBeluga_sexuallyActive',
    'libidoBeluga_recentStressors',
    {
      key: 'libidoBeluga_physicalExam',
      next: {
        condition: {
          'libidoBeluga_physicalExam.libidoBeluga_physicalExam_foundProblems':
            true
        },
        key: 'libidoBeluga_physicalExamDetails',
        els: 'libidoBeluga_bloodPressure'
      }
    },
    'libidoBeluga_physicalExamDetails',
    {
      key: 'libidoBeluga_bloodPressure',
      next: {
        condition: {
          'libidoBeluga_bloodPressure.libidoBeluga_bloodPressure_yes': true
        },
        key: 'libidoBeluga_bloodPressureValue',
        els: 'libidoBeluga_specificMedications'
      }
    },
    'libidoBeluga_bloodPressureValue',
    {
      key: 'libidoBeluga_specificMedications',
      next: {
        condition: {
          'libidoBeluga_specificMedications.libidoBeluga_specificMedications_none':
            true
        },
        key: 'libidoBeluga_cardiovascularSymptoms',
        els: 'libidoBeluga_ineligible'
      }
    },
    {
      key: 'libidoBeluga_cardiovascularSymptoms',
      next: {
        condition: {
          'libidoBeluga_cardiovascularSymptoms.libidoBeluga_cardiovascularSymptoms_none':
            true
        },
        key: 'libidoBeluga_additionalInfo',
        els: 'libidoBeluga_ineligible'
      }
    },
    'libidoBeluga_cardiovascularSymptoms',
    'libidoBeluga_additionalInfo',
    {
      key: 'libidoBeluga_treatmentConsent',
      next: {
        condition: {
          'libidoBeluga_treatmentConsent.libidoBeluga_treatmentConsent_disagree':
            true
        },
        key: 'libidoBeluga_ineligible',
        els: 'libidoBeluga_complete'
      }
    },
    'libidoBeluga_ineligible',
    'libidoBeluga_complete'
  ]
};
